var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"zui-logo",attrs:{"alt":"xiaoyanyun","src":_vm.src},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }